import React, { ImgHTMLAttributes } from "react";
import Image from "components/Elements/Image/Image.tsx";

interface LoadingImageElementI extends ImgHTMLAttributes<HTMLImageElement> {}

const LoadingImageElement = (props: LoadingImageElementI) => {
  return (
    <Image
      className="loader-animation-gif"
      name="preloader"
      ext="gif"
      alt=""
      title=""
      {...props}
    />
  );
};

export default LoadingImageElement;
